module.exports = "/static-assets/_next/static/images/Poloaroid-2-3c6962de5e16112bcf233a964a782795.png";